export default (eventId) => {
  if (window.ym) { // Yandex.Metrika
    window.ym(55949917, 'reachGoal', eventId)
  }

  if (window.gtag) { // Google Analytics
    window.gtag('event', eventId)
  }
}
